import type { IVInputConfig } from '~/misc/v-input/types';

const BASE_INPUT_CONFIG: IVInputConfig = {
  type: 'string',
  inputMode: 'text',
};

export { BASE_INPUT_CONFIG };
